import React from "react";
import PropTypes from "prop-types";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "@lottiefiles/lottie-player";
import "react-circular-progressbar/dist/styles.css";
import { toFarsiNumber } from "../Archive/utils";
import { CircleWithIcon } from "./Common";
import "@lottiefiles/lottie-player";
import * as cpu_json from "../../images/demo/main_section/CPUMotionFinal";

const Processing = (props) => {
  const CpuLottiePlayer = () => {
    // use from lottie-player package: https://github.com/LottieFiles/lottie-player
    return <lottie-player autoplay loop mode="normal" src={cpu_json.default} />;
  };
  return (
    <>
      {props.attaching ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "center",
          }}
        >
          {props.percentComplete < 100 ? (
            <>
              {" "}
              {/* Circular Progress */}
              <div
                style={{
                  width: "68px",
                  height: "68px",
                  marginBottom: "16px",
                  fontSize: "9px",
                  fontWeight: 500,
                  lineHeight: "31.09px",
                }}
              >
                <CircularProgressbar
                  value={props.percentComplete}
                  text={`%${toFarsiNumber(props.percentComplete)}`}
                  styles={buildStyles({
                    textColor: "#626262",
                    pathColor: "#007bff",
                    trailColor: "#fff",
                    textSize: "24px",
                    textAlign: "center",
                    pathTransitionDuration: 0.5,
                    textStyle: {
                      fontFamily: "IRANYekan",
                      fontWeight: 500,
                      lineHeight: "31.09px",
                    },
                  })}
                />
              </div>
              {/* Uploaded Size / Total Size */}
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: 300,
                  lineHeight: "20.73px",
                  textAlign: "center",
                  color: "#626262",
                  marginTop: "0px",
                }}
              >
                {toFarsiNumber(props.totalSize)}MB /{" "}
                {toFarsiNumber(props.loadedSize)}MB
              </div>
              {/* Persian Loading Text */}
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: 300,
                  lineHeight: "27.64px",
                  textAlign: "center",
                  color: "#626262",
                  marginTop: "12px",
                }}
              >
                ...در حال{" "}
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "27.64px",
                    textAlign: "center",
                    color: "#626262",
                    marginTop: "12px",
                  }}
                >
                  بارگذاری
                </span>
                <br />
                .لطفا منتظر بمانید
              </div>
            </>
          ) : (
            <div className={"processing " + props.classNames}>
              <CircleWithIcon
                backColor={props.backColor}
                ChildComponent={CpuLottiePlayer}
                classNames="icon-wrapper"
              />
              <div className="text">
                <div>در حال پردازش ...</div>
                <div>لطفا منتظر بمانید.</div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className={"processing " + props.classNames}>
          <CircleWithIcon
            backColor={props.backColor}
            ChildComponent={CpuLottiePlayer}
            classNames="icon-wrapper"
          />
          <div className="text">
            <div>در حال پردازش ...</div>
            <div>لطفا منتظر بمانید.</div>
          </div>
        </div>
      )}
    </>
  );
};

Processing.propTypes = {
  classNames: PropTypes.string,
  attaching: PropTypes.bool,
  backColor: PropTypes.string.isRequired,
};

Processing.defaultProps = {
  attaching: false,
  classNames: "",
};

export default Processing;
